import './index.css';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useContext, useCallback, Fragment } from 'react';
import { SnackbarContext } from './context.js';
import { s as styles } from './snackbar-CR_b_R8I.js';

const SnackbarContainer = ({ children, id, ...props }) => {
    const context = useContext(SnackbarContext);
    const ref = useCallback((instance) => {
        context.setContainerRef(id, instance);
    }, [id, context]);
    return (jsxs(Fragment, { children: [jsx("div", { ...props, className: styles.snackbarContainer, ref: ref }), children] }));
};

export { SnackbarContainer };
//# sourceMappingURL=SnackbarContainer.js.map
